import type { TimesheetMaterialRecord } from "@/features/timesheetFlow/timesheetFlowTypes";

export type TimesheetMaterialSourceType =
  | "order_line"
  | "bestellung_position"
  | "manual"
  | "hero"
  | "ma_position"
  | "gd_position";

const API_MATERIAL_SOURCE_TYPES = new Set<TimesheetMaterialSourceType>([
  "order_line",
  "bestellung_position",
  "manual",
  "hero",
  "ma_position",
  "gd_position",
]);

/** API-erlaubte source_type-Werte (wie normalizeMaterialSourceTypeForDb in stundennachweise.js). */
export function resolveMaterialSourceTypeForApi(
  raw: string | null | undefined,
  material?: Pick<TimesheetMaterialRecord, "artikel_id"> | null,
): TimesheetMaterialSourceType {
  const sourceType = String(raw || "").trim();
  if (API_MATERIAL_SOURCE_TYPES.has(sourceType as TimesheetMaterialSourceType)) {
    return sourceType as TimesheetMaterialSourceType;
  }

  const isHeroLinked = material?.artikel_id != null;
  const aliasMap: Record<string, TimesheetMaterialSourceType> = {
    order: "order_line",
    ordered_material: "order_line",
    lager: "ma_position",
    material_anforderung: "ma_position",
    ma: "ma_position",
    angebot_position: "gd_position",
    angebot: "gd_position",
    festpreis: "gd_position",
    customer_standard: isHeroLinked ? "hero" : "manual",
    ordner_standard: isHeroLinked ? "hero" : "manual",
    sordner_standard: isHeroLinked ? "hero" : "manual",
  };

  if (aliasMap[sourceType]) {
    return aliasMap[sourceType];
  }

  return isHeroLinked ? "hero" : "manual";
}

/** @deprecated Nutze resolveMaterialSourceTypeForApi */
export function normalizeMaterialSourceTypeForApi(
  raw: string | null | undefined,
): TimesheetMaterialSourceType {
  return resolveMaterialSourceTypeForApi(raw);
}

export function normalizeMaterialForApi(
  material: TimesheetMaterialRecord,
): TimesheetMaterialRecord {
  let source_type = resolveMaterialSourceTypeForApi(material.source_type, material);
  if (source_type === "manual" && material.artikel_id != null) {
    source_type = "hero";
  }
  return {
    ...material,
    source_type,
  };
}
